module.exports = __webpack_public_path__ + "img/1c_icon.705abb75.svg";